/* eslint import/prefer-default-export: "off" */
/* eslint-disable no-console */

import type {
  Graph,
  GraphEdge,
  GraphNode
} from '@src/components/vis.js.network.vis/models'
import { forEach } from 'lodash'
import { parseCamURI } from './url.utils'
import type { ResourceType, ResourceTypeDict } from '@src/redux/reducers/shell'
import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
export enum View {
  none,
  access,
  privilege,
  usage,
  crossAccount
}

export const parseGraph = (result_graph?: string): Graph => {
  try {
    return result_graph ? JSON.parse(result_graph) : {}
  } catch (error) {
    console.log('json graph parse failed', { error })
    return {}
  }
}

type MainOptions<T> = {
  mainIdKey: keyof T
  mainNameKey: keyof T
  typeKey: keyof T
  countKey: keyof T
}

type ResourceOptions<T> = {
  idKey: keyof T
  typeKey: keyof T
  nameKey: keyof T
}

interface ParseGraphProps<T> {
  withMain?: boolean
  prefix?: string
  data: T[]
  resourceTypes: ResourceTypeDict
  options: MainOptions<T> | ResourceOptions<T>
}

export function mapDataToGraph<T>({
  data,
  withMain = true,
  prefix = '',
  resourceTypes,
  options
}: ParseGraphProps<T>): Graph {
  let main: GraphNode = {
    num: String('main')
  }
  const graph: Graph = {
    nodes: [],
    links: [],
    paths: []
  }
  const hasMainOptions =
    (options as MainOptions<T>)?.mainIdKey &&
    (options as MainOptions<T>)?.mainNameKey
  forEach(data, (x, index) => {
    if (hasMainOptions && index < 1) {
      main = {
        ...main,
        id: x[(options as MainOptions<T>)?.mainIdKey as string],
        type: parseCamURI(x[(options as MainOptions<T>)?.mainIdKey as string])
          ?.type,
        name: x[(options as MainOptions<T>)?.mainNameKey as string]
      }
    }

    const nodeId = String(`${prefix}${index}`)
    const link: GraphEdge = {
      source: String('main'),
      target: nodeId,
      mlink: `mlink_${nodeId}`
    }
    const resType: ResourceType = resourceTypes[x[options?.typeKey as string]]
    const isCluster = x[(options as MainOptions<T>)?.countKey as string] > 0
    const nameForCluster = `${x[(options as MainOptions<T>)?.countKey]} ${
      x[(options as MainOptions<T>)?.countKey as string] > 1
        ? resType.display_name_plural
        : resType.display_name
    }`

    const nameForNode: string =
      x[(options as ResourceOptions<T>)?.nameKey as string]
    const node: GraphNode = {
      num: nodeId,
      cluster: isCluster && resType?.resource_num,
      type: ResourceTypeEnum[x[options?.typeKey as string]],
      id: isCluster
        ? x[options?.typeKey]
        : x[(options as ResourceOptions<T>)?.idKey as string],
      name: isCluster ? nameForCluster : nameForNode
    }

    graph.nodes.push(node)
    graph.links.push(link)
  })
  if (hasMainOptions && withMain && data?.length > 0) {
    graph.nodes.push(main)
  }

  return graph
}
